"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _theme = require("../../styles/theme");

var iconColors = {
  asterisk: {
    normal: _theme.colors.orange.primary
  },
  checkmark: {
    normal: _theme.colors.green
  },
  lock: {
    normal: _theme.colors.blue.primary
  },
  'c-logo': {
    normal: _theme.colors.blue.primary
  },
  spinner: {
    normal: _theme.colors.grey.primaryLight
  },
  unlock: {
    normal: _theme.colors.grey.secondaryDark
  },
  warning: {
    normal: _theme.colors.yellowDark
  },
  x: {
    normal: _theme.colors.grey.altDark,
    hover: _theme.colors.red.primary
  }
};
var _default = iconColors;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/icons/colors.js
// module id = 533
// module chunks = 0 15 16 17 18